jQuery(($) => {

    if ($('.m-logos-banner--is-slider')[0]) {
        $('.m-logos-banner--is-slider .m-logos-banner__list').slick({
            speed: 900,
            autoplay: true,
            autoplaySpeed: 2000,
            slidesToShow: 5,
            infinite: true,
            swipe: true,
            swipeToSlide: true,
            arrows: false,
            responsive: [
              {
                breakpoint: 950,
                settings: {
                    slidesToShow: 3,
                }
              }, 
              {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                }
              }
            ],
        });
    }

    if ($('.m-logos-banner--no-slider .m-logos-banner__list')[0]) {
        $(window).on('load resize', function () {
            if ($(window).width() > 950) {
                if ($('.m-logos-banner--no-slider .m-logos-banner__list').hasClass('slick-initialized')) {
                    $('.m-logos-banner--no-slider .m-logos-banner__list').slick('unslick');
                }
            } else if (!$('.m-logos-banner--no-slider .m-logos-banner__list').hasClass('slick-initialized')) {
                $('.m-logos-banner--no-slider .m-logos-banner__list').slick({
                    speed: 900,
                    autoplay: true,
                    autoplaySpeed: 2000,
                    slidesToShow: 3,
                    infinite: true,
                    swipe: true,
                    swipeToSlide: true,
                    arrows: false,
                    responsive: [{
                        breakpoint: 500,
                        settings: {
                            slidesToShow: 1
                        }
                    }]
                });
            }
        });
    }
});